const duration = 500

export function getAnimationDuration() {
    return duration
}

export function zoomIn() {
    window.map.getView().animate({
        zoom: map.getView().getZoom() + 1,
        duration: duration
  })
}

export function zoomOut() {
    window.map.getView().animate({
        zoom: map.getView().getZoom() - 1,
        duration: duration
  })
}
